import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useContext(AuthContext);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen bg-[#F4F5F7]">
      {/* Sidebar */}
      <div className="fixed inset-y-0 left-0 w-64 bg-[#1E3A8A] text-white">
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-center h-16 px-4 border-b border-[#1E3A8A]/20">
            <img src="/logo.svg" alt="edaxIQ" className="h-8 w-auto" />
          </div>
          <nav className="flex-1 px-4 py-4 space-y-1">
            <button
              onClick={() => navigate('/dashboard')}
              className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-md ${
                isActive('/dashboard')
                  ? 'bg-[#06B6D4] text-white'
                  : 'text-white/70 hover:bg-[#1E3A8A]/80 hover:text-white'
              }`}
            >
              Instagram Settings
            </button>
            <button
              onClick={() => navigate('/dashboard/message-templates')}
              className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-md ${
                isActive('/dashboard/message-templates')
                  ? 'bg-[#06B6D4] text-white'
                  : 'text-white/70 hover:bg-[#1E3A8A]/80 hover:text-white'
              }`}
            >
              Message Templates
            </button>
            <button
              onClick={() => navigate('/dashboard/business-information')}
              className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-md ${
                isActive('/dashboard/business-information')
                  ? 'bg-[#06B6D4] text-white'
                  : 'text-white/70 hover:bg-[#1E3A8A]/80 hover:text-white'
              }`}
            >
              Business Information
            </button>
            <button
              onClick={() => navigate('/dashboard/analytics')}
              className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-md ${
                isActive('/dashboard/analytics')
                  ? 'bg-[#06B6D4] text-white'
                  : 'text-white/70 hover:bg-[#1E3A8A]/80 hover:text-white'
              }`}
            >
              Analytics
            </button>
            <button
              onClick={() => navigate('/dashboard/updates')}
              className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-md ${
                isActive('/dashboard/updates')
                  ? 'bg-[#06B6D4] text-white'
                  : 'text-white/70 hover:bg-[#1E3A8A]/80 hover:text-white'
              }`}
            >
              Updates
            </button>
            <button
              onClick={() => navigate('/dashboard/account')}
              className={`w-full flex items-center px-4 py-2 text-sm font-medium rounded-md ${
                isActive('/dashboard/account')
                  ? 'bg-[#06B6D4] text-white'
                  : 'text-white/70 hover:bg-[#1E3A8A]/80 hover:text-white'
              }`}
            >
              Account Details
            </button>
          </nav>
          <div className="p-4 border-t border-[#1E3A8A]/20">
            <button
              onClick={handleLogout}
              className="w-full flex items-center px-4 py-2 text-sm font-medium text-white/70 hover:bg-[#1E3A8A]/80 hover:text-white rounded-md"
            >
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="pl-64">
        <main className="py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}; 